export const faqs = [
  {
    question: '91影视看片app是免费的吗？',
    answer: '是的，91影视看片app完全免费使用，所有影视内容均可免费在线观看。我们致力于为用户提供优质的免费观影体验，无任何隐藏收费。',
  },
  {
    question: '91影视看片app支持哪些手机系统？',
    answer: '91影视看片app全面支持安卓（Android 7.0及以上版本）和苹果iOS（iOS 13.0及以上版本）系统。无论是华为、小米、OPPO、vivo等国产安卓手机，还是iPhone系列，都可以流畅运行。',
  },
  {
    question: '如何下载安装91影视看片app？',
    answer: '您可以在本页面点击对应的下载按钮获取安装包。安卓用户下载APK文件后直接安装即可；苹果用户可通过提供的企业签名链接进行安装。安装前请确保手机允许安装未知来源应用。',
  },
  {
    question: '91影视看片app安全吗？会不会有病毒？',
    answer: '91影视看片app经过多重安全检测，无毒无插件，请放心使用。我们采用严格的安全审核机制，所有安装包均通过主流安全软件的检测认证，保障用户设备安全。',
  },
  {
    question: '观看视频需要注册账号吗？',
    answer: '91影视看片app支持免注册直接观看，打开即用。注册账号后可以享受更多功能，如同步观看记录、收藏影片、个性化推荐等。我们提供手机号快捷注册方式。',
  },
  {
    question: '为什么有时候视频加载比较慢？',
    answer: '视频加载速度主要受网络环境影响。建议在Wi-Fi或稳定的4G/5G网络下观看。如果遇到加载慢的情况，可以尝试切换清晰度或更换播放线路，91影视app提供多线路切换功能以确保最佳播放体验。',
  },
  {
    question: '可以在多个设备上同时使用吗？',
    answer: '当然可以！注册账号后，您可以在手机、平板等多个设备上登录使用91影视看片app，观看记录和收藏列表会自动同步，随时随地无缝切换设备继续追剧。',
  },
  {
    question: '91影视看片app的内容更新频率如何？',
    answer: '91影视看片app拥有专业的内容更新团队，热门电影、电视剧、综艺节目保持每日更新。新上映的院线电影一般在上映后1-2周内上线，热播电视剧同步更新，确保用户第一时间看到最新内容。',
  },
];